import { initReactI18next } from "react-i18next";
import i18n from "i18next";

import en from "./locale/en";
import ja from "./locale/ja";

const resources = {
  en: en,
  ja: ja,
};

i18n.use(initReactI18next).init({
  resources,
  lng: "ja",
  debug: false,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
